function related_product_slider_init() {
 $(".relatited-product-slider").slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><img src="//kaeruwa.com/cdn/shop/t/87/assets/blog-left.jpg?v=13365841140018341421747100002"></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="//kaeruwa.com/cdn/shop/t/87/assets/blog-right.jpg?v=72307245816322117551747100002"></button>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
      });    
}
$(function(){
  
  if( typeof $(".relatited-product-slider").slick === 'function' ) {
     related_product_slider_init();
  }else {
      const script = document.createElement('script');
      script.src = 'https://kaeruwa.com/cdn/shop/t/1/assets/slick.min.js';
      script.onload = related_product_slider_init;
      document.head.appendChild(script);
  }
  $("header-menu details summary").on("click", function() {
    $(".header-under-menu-toggle").slideUp();
  });
  $(".header-under-menu-toggle").hide();


  w = $(window).width();
  if( w < 990 ) {

    $(".header-sub-common li.has-child a").on("click", function (event) {
      event.preventDefault();

      return false;
    });

    $(".has-accordion").on("click", function () {
      $(this).toggleClass("acc-on");
      $(this).find(".accordion-item").slideToggle();
    });
  }

});

  // 初回チェック
  checkBreakPoint();
  Dropdown();
  
  $(window).resize(function(){
  	Dropdown();
  	checkBreakPoint();
  });


function checkBreakPoint() {
	w = $(window).width();
	if (w <= 430) {
		$('.menu-sp-slider').not('.slick-initialized').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
           variableWidth: true,
            autoPlay: false,
            infinite: false,
            arrows: true,
           prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><img src="//kaeruwa.com/cdn/shop/t/87/assets/scroll-btn-left_small.jpg?v=26502622117284626521747100056"></button>',
           nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="//kaeruwa.com/cdn/shop/t/87/assets/scroll-btn-right_small.jpg?v=139521783884419439771747100057"></button>', 
		});
	} else {
		// PC向け
		if( $('.menu-sp-slider').hasClass('.slick-initialized') ) {
          $('.menu-sp-slider').slick('unslick');
        };
	}
}
  
function Dropdown() {
	w = $(window).width();
    var isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	if (isTouchDevice) {

        $('.level1').off();
      
		$('.level1').on("touchend", function (){
           let _target = $(this).find(".level1_item").attr('data-child-target'); 
           $(".header-under-menu-toggle").each(function(index) {
            if( $(this).hasClass(_target) ) {
              $("."+ _target).slideToggle();
            }else {
              $(this).slideUp();
            }
          })
        });
	} else {

        $('.level1').off();
      
      	$('.level1.has-child').click(function(){
          event.preventDefault();
          let _target = $(this).find(".level1_item").attr('data-child-target');
          
          $(".header-under-menu-toggle").each(function(index) {
            if( $(this).hasClass(_target) ) {
              $(this).slideToggle();
            }else {
              $(this).slideUp();
            }
          })
        });
	}
}

